import { headers } from "../../App/Axios"
import HTTPService from "../../App/HTTPService"

export const chatListGetRequest = (pageNumber:number=1) => {
    return HTTPService.get(`conversation?page=${pageNumber}`,headers)
}

export const chatGetByPartnerIdRequest = (partnerId:number
) => {
    return HTTPService.get(`conversation/partnerId/${partnerId}`,headers)
}

export const singleChatListGetRequest = (conversationId : number) => {
    return HTTPService.get(`conversation/${conversationId}`,headers)
}

export const ConversationMessageGetRequest = (conversationId: number, pageNumber:number) => {
    return HTTPService.get(`/conversation/${conversationId}/messages?page=${pageNumber}`, headers)
}

export const CreateConversationPostRequest = (partnerId: number,userId: number) => {
    return HTTPService.post(`conversation/`, { member: partnerId } , headers)
}

export const ConversationLeaveRequest = (conversationId: number) => {
    return HTTPService.delete(`/conversation/${conversationId}/leave`)
}

export const ConversationMessagePatchRequest = (conversationId: number, messageId: number, content: string) => {
    return HTTPService.patch(`/conversation/${conversationId}/message/${messageId}`, { content }, headers)
}

export const ConversationMessageSeenPostRequest = (conversationId: number, messages: number[]) => {
    return HTTPService.post(`/conversation/${conversationId}/messages/seen`, { messages }, headers)
}